import { createFileRoute, Link } from '@tanstack/react-router';
import { WorkerOnboardingForm } from '../components/forms/WorkerOnboardingForm.js';
import { requireRole } from '../lib/auth-guard.js';

export const Route = createFileRoute('/worker/onboarding')({
  component: WorkerOnboardingPage,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['worker']);
  },
});

function WorkerOnboardingPage() {
  return (
    <div className="min-h-screen p-6 max-w-3xl mx-auto space-y-6">
      <Link to="/worker" className="text-sm text-[var(--muted-foreground)] hover:text-foreground">
        ← Zurück zur Übersicht
      </Link>
      <WorkerOnboardingForm />
    </div>
  );
}
